import { RequestMaker } from './request-maker'

const REQUEST_MAKER = new RequestMaker()

export const useRequests = (): RequestMaker => {
  return REQUEST_MAKER
}
